import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mqttClient: null,
    deviceList: [],
    logFilesData: {},
    propertiesData: {},
    screenShotImgArr: [],
    flagAdd: 0,
    // 🆕 登入相關狀態
    token: (() => {
      const token = localStorage.getItem('auth_token')
      const expires = localStorage.getItem('auth_expires')
      if (token && expires && Date.now() < parseInt(expires)) {
        return token
      }
      // Token 過期，清除資料
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_expires')
      localStorage.removeItem('user_info')
      return null
    })(),
    user: (() => {
      const token = localStorage.getItem('auth_token')
      const expires = localStorage.getItem('auth_expires')
      if (token && expires && Date.now() < parseInt(expires)) {
        return JSON.parse(localStorage.getItem('user_info') || 'null')
      }
      return null
    })(),
    isAuthenticated: (() => {
      const token = localStorage.getItem('auth_token')
      const expires = localStorage.getItem('auth_expires')
      return !!(token && expires && Date.now() < parseInt(expires))
    })()
  },
  mutations: {
    propertiesData (state, value) {
      state.propertiesData = value
    },
    flagAdd (state, value) {
      state.flagAdd = value
    },
    screenShotImgArr (state, value) {
      state.screenShotImgArr = value
    },
    AddmqttClient (state, value) {
      state.mqttClient = value
    },
    deviceList (state, value) {
      state.deviceList = value
    },
    logFilesData (state, value) {
      state.logFilesData = value
    },
    // 🆕 登入相關 mutations
    SET_TOKEN (state, token) {
      state.token = token
      state.isAuthenticated = !!token
      if (token) {
        // 🆕 設置 12 小時後過期
        const expiresAt = Date.now() + (12 * 60 * 60 * 1000)
        localStorage.setItem('auth_token', token)
        localStorage.setItem('auth_expires', expiresAt.toString())
      } else {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('auth_expires')
      }
    },
    SET_USER (state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('user_info', JSON.stringify(user))
      } else {
        localStorage.removeItem('user_info')
      }
    },
    CLEAR_AUTH (state) {
      state.token = null
      state.user = null
      state.isAuthenticated = false
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_expires')
      localStorage.removeItem('user_info')
    }
  },
  actions: {
    updateSelectedRows ({ commit }, rows) {
      commit('setSelectedRows', rows)
    },
    updateFiles ({ commit }, files) {
      commit('setFiles', files)
    },
    // 🆕 登入相關 actions
    login ({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
    },
    logout ({ commit }) {
      commit('CLEAR_AUTH')
    }
  },
  modules: {
  },
  getters: {
    // 🆕 便於組件使用的 getters
    isLoggedIn: state => state.isAuthenticated,
    currentUser: state => state.user,
    authToken: state => state.token
  }
})
